import React, { Component, Fragment } from 'react'
import Breadcrumbs from '../../shared/Breadcrumbs'
import { TagMatchersRoute } from '../../routing'

export class TagMatchersPage extends Component {
    render() {
        return (
            <Fragment>
            <Breadcrumbs />
            <TagMatchersRoute />
          </Fragment>
        )
    }
}
